"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSentryInterface = void 0;
const browser_1 = require("@sentry/browser");
const createSentryInterface = (config) => {
    const sentryClient = new browser_1.BrowserClient({
        dsn: config.dsn,
        integrations: [
            new browser_1.BrowserTracing(),
            new browser_1.Breadcrumbs(),
            new browser_1.BrowserProfilingIntegration(),
            new browser_1.Dedupe(),
            new browser_1.HttpContext(),
            new browser_1.LinkedErrors(),
            new browser_1.TryCatch(),
            new browser_1.FunctionToString(),
            new browser_1.InboundFilters(),
        ],
        tracesSampleRate: config.environment !== "production" ? 1.0 : 0.1,
        transport: browser_1.makeFetchTransport,
        stackParser: browser_1.defaultStackParser,
        release: config.version,
        environment: config.environment,
    });
    const hub = new browser_1.Hub(sentryClient);
    (0, browser_1.makeMain)(hub);
    const reportingServiceName = "sentry";
    const captureException = (error) => {
        return hub.captureException(error);
    };
    const setTags = (tags) => {
        hub.setTags(tags);
    };
    const setTag = (key, value) => {
        hub.setTag(key, value);
    };
    return {
        reportingServiceName,
        captureException,
        setTag,
        setTags,
        instance: hub,
    };
};
exports.createSentryInterface = createSentryInterface;
